<template>
    <tr class="child-row">
        <td :colspan="colspan" class="child-td">
            <table class="table create-billing table-width table-sm child-table table-bordered">
                <tbody class="child-table-body">
                    <tr v-for="(item, index) in childItems" :key="item.id">
                        <td class="chk-td d-flex justify-content-around align-items-center">
                            <div v-if="item.status != 'completed'" @click="onOpenEditModal(item, index)" class="edit-action">
                              <i class="fa fa-pencil"></i>
                            </div>
                            <div @click="onClickToRx(item)" title="Prescription" class="rx-action">
                              <i class="fas fa-prescription"></i>
                            </div>
                            <div v-if="item.status != 'completed'" @click="deleteServiceTask(item.id, index)" class="delete-action">
                              <i class="far fa-times-circle close"></i>
                            </div>
                            <input disabled type="checkbox" class="form-check-input" v-model="item.is_done" />
                        </td>
                        <td>{{ index + 1 }}</td>
                        <td>{{ item.log_values && item.log_values.activities ? item.log_values.activities.map(activity => activity.name).join(', ') : '' }}</td>
                        <td>{{ formatRawDate(item.start_time) }}</td>
                        <td>{{ formatRawDate(item.end_time) }}</td>
                        <td>{{ item.log_values && item.log_values.assigned_to ? item.log_values.assigned_to.name : '' }}</td>
                        <td>{{ item.log_values && item.log_values.report_to ? item.log_values.report_to.name : '' }}</td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </td>
        <Loader v-if="loading" />
    </tr>
</template>
<script setup>
import { formatRawDate } from '@/services/utils/global.js';
import handleDentalOs from '@/services/modules/dental-os/dentalOs';
import { inject, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ref } from 'vue';
import Loader from "@/components/atom/LoaderComponent";
import handleActivity from "@/services/modules/procurement/activity";
import { useStore } from 'vuex';
import { cloneDeep } from 'lodash';

const props = defineProps({
    colspan: {
        type: Number,
        default: 8
    },
    childItems: {
        type: Array,
        default: () => []
    },
});

const { deleteTask, fetchSingleTask } = handleDentalOs();
const { updateMarkAsDoneTaskActivityLog } = handleActivity();

const showError = inject('showError');
const showSuccess = inject('showSuccess');
const route = useRoute();
const router = useRouter();
const emit = defineEmits(['onOpenEditModal', 'onClickToRx']);

const onClickToRx = (item) => {
    if (! item.activitylogable_id) return;
    const query = {
        ...cloneDeep(route.query),
        general_id: item.activitylogable_id,
        task_id: item.id,
        back_url: encodeURIComponent(route.fullPath)
    };
    const resolved = router.resolve({
        name: 'dental-service',
        params: {
            ...route.params,
            serviceId: route.params.serviceId
        },
        query: query,
        hash: '#prescription'
    });
    window.open(resolved.href, '_blank');
}
const loading = ref(false);
const store = useStore();

const onOpenEditModal = async (item, index) => {
    if (item.is_done) return;

    const companyId = route.params.companyId;

    loading.value = true;

    await fetchSingleTask(item.id, `?company_id=${companyId}`)
    .then((res) => {
        if(res.status){
            emit('onOpenEditModal', res.data, index);
        }
    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        loading.value = false;
    })
}

const deleteServiceTask = (id, index) => {
    const task = props.childItems[index];
    if (task && task.is_done) return;

    if (! confirm('Are you sure you want to delete this task?')) {
        return;
    }
    
    const query = getQuery();

    deleteTask(id, query).then(res => {
        if (! res.status) {
            return showError(res.message);
        }

        showSuccess(res.message);
        props.childItems.splice(index, 1);
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    return query;
}

onMounted(async () => {
    const taskId = route.query.task_id;
    if (! taskId) return;
    
    const item = props.childItems.find(item => item.id == taskId);
    if (! item) return;

    store.commit('dental/setTaskItem', cloneDeep(item));

    item.is_done = true;
})


</script>

<style scoped>
.chk-td {
    padding-right: 0 !important;
    padding-left: 13px !important;
}
.chk-td .form-check-input {
    pointer-events: none;
}
.table tbody tr {
    cursor: auto !important;
}
.form-check-input:checked {
    background-color: #5ad886;
    border-color: #5ad886;
}
.child-table-body {
    background-color: #ffffd3;
}
.child-td {
    padding: 15px 25px !important;
}
.delete-action {
    cursor: pointer;
    color: red;
}
.rx-action {
    cursor: pointer;
    font-size: 12px;
    color: #7367f0;
}
.edit-action {
    cursor: pointer;
    font-size: 12px;
}
</style>
